import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { authAPI } from '../api';
import { useAuthStore } from '../store';
import { toast } from 'sonner';
import { readFirstTouch } from '../lib/firstTouch';
import { consumePostSignupRedirect } from '../lib/postSignupRedirect';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const setUser = useAuthStore((state) => state.setUser);
  const hasProcessed = useRef(false);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      console.log('[AUTH CALLBACK] Starting session processing...');
      console.log('[AUTH CALLBACK] Location hash:', location.hash);
      
      try {
        const hash = location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');
        
        console.log('[AUTH CALLBACK] Extracted session_id:', sessionId ? sessionId.substring(0, 20) + '...' : 'null');

        if (!sessionId) {
          console.error('[AUTH CALLBACK] No session_id found in URL hash');
          toast.error('Invalid authentication response');
          navigate('/login');
          return;
        }

        console.log('[AUTH CALLBACK] Calling exchangeSession API...');
        const response = await authAPI.exchangeSession(sessionId, readFirstTouch());
        console.log('[AUTH CALLBACK] exchangeSession response:', {
          hasUser: !!response.data,
          email: response.data?.email,
          hasSessionToken: !!response.data?.session_token,
          sessionTokenPrefix: response.data?.session_token?.substring(0, 20)
        });
        
        const user = response.data;
        setUser(user);
        
        // Verify token was stored
        const storedToken = localStorage.getItem('session_token');
        console.log('[AUTH CALLBACK] Token verification:', {
          tokenStored: !!storedToken,
          storedTokenPrefix: storedToken?.substring(0, 20)
        });
        
        // Post-signup redirect hook (/try, /c/:id, …): same-origin path, used once.
        const redirectTo = consumePostSignupRedirect();
        console.log('[AUTH CALLBACK] Navigating to', redirectTo || '/dashboard');
        navigate(redirectTo || '/dashboard', { state: { user }, replace: true });
      } catch (error) {
        console.error('[AUTH CALLBACK] Auth error:', error);
        console.error('[AUTH CALLBACK] Error details:', {
          message: error.message,
          response: error.response?.data,
          status: error.response?.status
        });
        toast.error('Authentication failed');
        navigate('/login');
      }
    };

    processSession();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
        <p className="mt-4 text-muted-foreground">Completing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
